import React, { useState } from "react";
import { dialog } from "@microsoft/teams-js";
import { Flex, Button } from "@fluentui/react-northstar";
import { useApp } from "../../contexts/appContext";
import styles from "./commonModal.module.scss";
import IUser from "../../interfaces/IUser";
import UserPicker from "../pickers/userPicker";

const AssignOwner = () => {
  const [user, setUser] = useState<IUser>();
  const { state: appState } = useApp();
  const { isDarkTheme } = appState;

  const confirmDialog = async () => {
    dialog.url.submit(user);
  }

  return (
    <Flex gap="gap.medium" column className={styles.container} style={{ backgroundColor: isDarkTheme ? "#292929" : "#FFFFFF" }}>
      <Flex column gap="gap.smaller" fill>
        <small>Nový vlastník</small>
        <UserPicker selectedUserId={user?.id} userSelected={(u) => setUser(u)} />
      </Flex>
      <Flex>
        <Flex fill></Flex>
        <Flex gap="gap.medium">
          <Button content="Zrušit" onClick={() => dialog.url.submit()} />
          <Button content="Potvrdit" primary onClick={confirmDialog} disabled={!user} />
        </Flex>
      </Flex>

    </Flex>
  );
};

export default AssignOwner;
